export default __webpack_public_path__ + "static/media/FullName.41e68a83.svg";